import { VoucherType } from '@prisma/client';
import { Box, Flex, Text } from '@mantine/core';
import { MyIcon } from '@web/common-ui';
import { COLORS } from '../questionnaires/components/constants';
import {
  RedeemButton,
  RedeemedVouchers,
} from '../questionnaires/components/VoucherStates';

export interface WaitingVoucherRowProps {
  label: string;
  dateLabel?: string;
  isFirstRow?: boolean;
  voucherAllowanceId?: number;
  vouchers?: Array<{ code: string; type: VoucherType }>;
  redeemAmount?: string;
  onRedeem: (id: number) => void;
  isSmallScreen: boolean;
}

export const WaitingVoucherRow = ({
  label,
  dateLabel,
  isFirstRow = false,
  voucherAllowanceId,
  vouchers,
  redeemAmount,
  onRedeem,
  isSmallScreen,
}: WaitingVoucherRowProps) => {
  return (
    <Box
      bg="#FBFBF8"
      p="12px 20px"
      style={{
        borderRadius: isSmallScreen || !isFirstRow ? 0 : '8px 8px 0 0',
        borderBottom: '1px solid #edece8',
      }}
      w="100%"
    >
      <Flex
        direction={isSmallScreen ? 'column' : 'row'}
        justify="space-between"
        align={isSmallScreen ? 'flex-start' : 'center'}
        w="100%"
        gap={isSmallScreen ? '10px' : '16px'}
      >
        <Flex align="center" gap="12px">
          <MyIcon name="questionnaire" />
          <Flex
            direction={isSmallScreen ? 'column' : 'row'}
            gap={isSmallScreen ? '2px' : '12px'}
            align={isSmallScreen ? 'flex-start' : 'center'}
          >
            <Text fw={700} size="16px" c={COLORS.TEXT_PRIMARY}>
              {label}
            </Text>
            {dateLabel && (
              <Text
                fw={400}
                size={isSmallScreen ? '14px' : '16px'}
                c={COLORS.TEXT_PRIMARY}
              >
                {dateLabel}
              </Text>
            )}
          </Flex>
        </Flex>

        {voucherAllowanceId !== undefined ? (
          <RedeemButton
            onRedeem={() => onRedeem(voucherAllowanceId)}
            fullWidth={isSmallScreen}
            amount={redeemAmount}
          />
        ) : (
          vouchers && (
            <RedeemedVouchers vouchers={vouchers} fullWidth={isSmallScreen} />
          )
        )}
      </Flex>
    </Box>
  );
};
